import handleAccordionClick from '/src/components/accordion/accordion';

const articlePricesListRef = document.querySelector('[data-article-prices-list]');

articlePricesListRef?.addEventListener('click', handleAccordionClick);
